export const baseURL = "https://backend.taskgeniussoftware.com/" // "https://backend.aistaffs.com/" 
export const appName = "Taskgeniussoftware"
export const loginFooter = "taskgeniussoftware.com"
export const navBar = ".taskgeniussoftware.com"  //NOTE DO NOT FORGET TO ADD . OR - FO THE URL
